import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL, API_KEY_ID, API_KEY_SECRET } from '../../constant'
import axios from 'axios'

/**
 * Add Product to Favourites
 */
export const addFavourite = createAsyncThunk('favourite/addFavourite', async (productId, { rejectWithValue }) => {
    try {
        const token = localStorage.getItem('token');
        const headers = {
            'X-API-KEY-ID': API_KEY_ID,
            'X-API-KEY-SECRET': API_KEY_SECRET,
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const res = await axios.get(`${API_BASE_URL}/favourite/add/${productId}`, {
            headers,
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * Remove Product from Favourites
 */
export const removeFavourite = createAsyncThunk('favourite/removeFavourite', async (productId, { rejectWithValue }) => {
    try {
        const token = localStorage.getItem('token');
        const headers = {
            'X-API-KEY-ID': API_KEY_ID,
            'X-API-KEY-SECRET': API_KEY_SECRET,
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const res = await axios.get(`${API_BASE_URL}/favourite/remove/${productId}`, {
            headers,
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * List Favourite Products
 */
export const listFavourite = createAsyncThunk('favourite/listFavourite', async (_, { rejectWithValue }) => {
    try {
        const token = localStorage.getItem('token');
        const headers = {
            'X-API-KEY-ID': API_KEY_ID,
            'X-API-KEY-SECRET': API_KEY_SECRET,
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const res = await axios.get(`${API_BASE_URL}/favourite/list`, {
            headers,
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * List Favourite Product IDs
 */
export const listFavouriteIds = createAsyncThunk('favourite/listFavouriteIds', async (_, { rejectWithValue }) => {
    try {
        const token = localStorage.getItem('token');
        const headers = {
            'X-API-KEY-ID': API_KEY_ID,
            'X-API-KEY-SECRET': API_KEY_SECRET,
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const res = await axios.get(`${API_BASE_URL}/favourite/listids`, {
            headers,
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});